/* SPOILT — product video quality lock + selector
   1. Plays only the highest-quality progressive MP4 (no HLS / adaptive
      bitrate), so quality never drops on slow connections; it buffers instead.
   2. Adds a video chooser when a product has more than one video.
   Reuses the existing <video> element, so controls from spoilt-product.js
   (play/pause, progress, mute, fullscreen) keep working unchanged. */
(function () {
  'use strict';

  function bestSources(item) {
    var mp4 = item.sources.filter(function (source) {
      return /mp4/i.test(source.type || '') || /\.mp4(\?|$)/i.test(source.url || '');
    });
    if (!mp4.length) return item.sources;
    mp4.sort(function (a, b) {
      return (b.height || 0) - (a.height || 0);
    });
    return [mp4[0]];
  }

  function init() {
    var pip = document.querySelector('[data-video-pip]');
    var dataEl = document.getElementById('SpoiltVideoSelectData');
    if (!pip || !dataEl || pip.getAttribute('data-video-select-ready')) return;

    var video = pip.querySelector('video');
    var row = pip.querySelector('.spoilt-video-bottom-row');
    if (!video) return;

    var items = [];
    try {
      items = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var seen = {};
    items = (Array.isArray(items) ? items : []).filter(function (item) {
      if (!item || !item.sources || !item.sources.length) return false;
      var key = String(item.id);
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });

    if (!items.length) return;
    pip.setAttribute('data-video-select-ready', 'true');

    video.preload = 'auto';

    function setSources(item) {
      var wasMuted = video.muted;

      Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
        source.parentNode.removeChild(source);
      });
      video.removeAttribute('src');

      bestSources(item).forEach(function (source) {
        var node = document.createElement('source');
        node.src = source.url;
        if (source.type) node.type = source.type;
        video.appendChild(node);
      });

      if (item.poster) video.poster = item.poster;

      video.load();
      video.muted = wasMuted;

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }

    /* Lock the first video to the highest-quality MP4. */
    var firstBest = bestSources(items[0]);
    if (firstBest.length === 1) {
      var wanted = String(firstBest[0].url || '').split('?')[0];
      var playing = String(video.currentSrc || '').split('?')[0];
      if (wanted && wanted !== playing) setSources(items[0]);
    }

    if (items.length < 2 || !row) return;

    var current = 0;
    var buttons = [];
    var picker = document.createElement('div');
    picker.className = 'spoilt-video-picker';
    picker.setAttribute('role', 'group');
    picker.setAttribute('aria-label', 'Choose video');

    items.forEach(function (item, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'spoilt-video-pick' + (index === 0 ? ' is-active' : '');
      button.setAttribute('aria-label', 'Play video ' + (index + 1) + ' of ' + items.length);
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      if (item.alt) button.title = item.alt;
      if (item.poster) button.style.backgroundImage = 'url("' + item.poster + '")';

      var number = document.createElement('span');
      number.textContent = String(index + 1);
      button.appendChild(number);

      button.addEventListener('click', function (event) {
        event.stopPropagation();
        select(index);
      });

      picker.appendChild(button);
      buttons.push(button);
    });

    row.insertBefore(picker, row.firstChild);

    function select(index) {
      var item = items[index];
      if (!item || index === current) return;
      current = index;

      setSources(item);

      buttons.forEach(function (button, buttonIndex) {
        var active = buttonIndex === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
